import React from 'react';
import { useTranslation } from 'react-i18next'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import ListItemIcon from '@mui/material/ListItemIcon'
import Avatar from '@mui/material/Avatar'
import CategoryIcon from '@mui/icons-material/Category';

import isArray from 'lodash/isArray'
import get from 'lodash/get'
import map from 'lodash/map'

import OCLLogo from '../common/OCLLogo'
import { WHITE } from '../../common/colors'
import { formatDate } from '../../common/utils'


const CommunityBlog = ({ sx }) => {
  const { t } = useTranslation()
  const [feed, setFeed] = React.useState(false)


  const fetchFeed = () => {
    fetch(window.location.href.includes('https://') ? 'https://openconceptlab.org/feed/' : '/api/feed/')
      .then(response => response.text())
      .then(xml => {
        // Parse RSS as inert XML and expose only plain text and HTTP links.
        const document = new DOMParser().parseFromString(xml, 'application/xml')
        if (document.querySelector('parsererror')) throw new Error('Invalid RSS feed')
        const items = Array.from(document.querySelectorAll('channel > item')).map(item => {
          const link = item.querySelector('link')?.textContent?.trim() || ''
          return {
            title: item.querySelector('title')?.textContent || '',
            published: item.querySelector('pubDate')?.textContent || '',
            links: /^https?:\/\//i.test(link) ? [{url: link}] : [],
          }
        }).filter(item => item.links.length)
        setFeed({items})
      })
      .catch(() => setFeed({items: []}));
  }

  React.useEffect(() => {
    fetchFeed()
  }, [])

  return (
    <Card variant='outlined' sx={{height: 'calc(298px - var(--announcement-height, 0px))', borderRadius: '10px', display: 'inline-block', width: '100%', overflow: 'auto', ...sx}}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'primary.main' }}>
            <OCLLogo color={WHITE} width="30px" height="16px" />
          </Avatar>
        }
        title={t('dashboard.community_blog')}
        sx={{paddingBottom: 0, '.MuiCardHeader-content': {minWidth: 0}, '.MuiCardHeader-title': {color: 'surface.dark', fontWeight: 'bold', overflowWrap: 'anywhere'}}}
      />
      <CardContent sx={{padding: '0px 16px 16px 16px'}}>
        {
          isArray(feed?.items) && feed?.items?.length > 0 &&
            <List dense sx={{padding: 0}}>
              {
                map(feed.items, (item, index) => (
                  <ListItem disablePadding key={index}>
                    <ListItemButton sx={{padding: '4px 8px'}} href={get(item, 'links.0.url') || 'undefined'} target='_blank' rel='noreferrer noopener'>
                      <ListItemIcon sx={{minWidth: '44px'}}>
                        <CategoryIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={item.title}
                        secondary={formatDate(item.published)}
                        sx={{minWidth: 0, overflowWrap: 'anywhere', '.MuiListItemText-primary': { fontSize: '14px'}, '.MuiListItemText-secondary': { fontSize: '12px'}}}
                      />
                    </ListItemButton>
                  </ListItem>
                ))
              }
            </List>
        }
      </CardContent>
    </Card>
  )
}
export default CommunityBlog
